import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { JobType } from '../state-man/models/job-type.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class JobTypeService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  // version: the one that came with the list already held, or '' for none.
  public async getAll (version: string) : Promise<{ version: string, rows: JobType[] | null } | null> {      
    try {
      const ret = await this.apiService.getVersionedList('job_type/active/', version)
      return ret && { version: ret.version, rows: ret.rows && JobType.buildMany(ret.rows) }
    } 
    catch (error) {    
      LoggerService.log(error + 'job_type/active/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')      
      return null
    }
  }  
  
}
